import type { ComponentProps } from 'react';

import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { Link } from '@eliadmin/core/src/components/link';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/** Figma „Späť na prihlásenie“: DLZ/Body/M Medium in text/brand with a 20 px caret, 4 px apart. */
const ACTION_CLASS =
  'dlz-body-m-medium inline-flex items-center gap-1 rounded-sm text-[#D7191F] transition-colors hover:text-[#B5141A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012] focus-visible:ring-offset-2';

export function ActionLink({ children, className, ...props }: ComponentProps<typeof Link>) {
  return (
    <Link className={cn(ACTION_CLASS, className)} {...props}>
      {children}
      <Icon name="caret-right" size={20} />
    </Link>
  );
}

export function ActionButton({ children, className, ...props }: ComponentProps<'button'>) {
  return (
    <button type="button" className={cn(ACTION_CLASS, className)} {...props}>
      {children}
      <Icon name="caret-right" size={20} />
    </button>
  );
}
